import React from "react"

import {PaymentCurrencyType, StatementItem, WalletEntityType} from "@irati/types"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import withBranding from "@irati/brand/withBranding"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"

import PrimaryDetails from "../../../PrimaryDetails"
import {StyledCard} from "../../styled"
import ExpanderItem from "../../../ExpanderItem"
import SecondaryDetails from "../../../SecondaryDetails/ViewMessage"

interface Props extends InjectIntl {
  statementItem: StatementItem
  className?: string
}

const PromotionalPointsTransfer = (props: Props) => {
  const {statementItem, formatMessage, className} = props
  const {currency, amount, message, walletType} = statementItem.transfer || {}

  const primaryDetails = {
    image: perkboxLogo,
    title:
      walletType === WalletEntityType.Reward ? (
        <FormattedMessage id="wallet.statementItem.promotional.reward.primaryDetails.title" />
      ) : currency === PaymentCurrencyType.Tt ? (
        <FormattedMessage id="wallet.statementItem.promotional.user.primaryDetails.fp.title" />
      ) : (
        <FormattedMessage id="wallet.statementItem.promotional.user.primaryDetails.rp.title" />
      ),
    subTitle: formatMessage({id: "wallet.statementItem.adminReward.transfer.subTitle"}),
    amount: getNormalisedValue(currency !== PaymentCurrencyType.Tt, currency, Math.abs(amount)),
    currency,
    status: StatusType.CLEARED
  }

  if (!statementItem.transfer?.message) {
    return (
      <StyledCard medium noBorder>
        <PrimaryDetails imgHeightAuto data={primaryDetails} />
      </StyledCard>
    )
  }

  const secondaryDetails = {
    message,
    userMessage:
      walletType === WalletEntityType.Reward ? (
        <FormattedMessage id="wallet.statementItem.promotional.reward.secondaryDetails.title" />
      ) : currency === PaymentCurrencyType.Tt ? (
        <FormattedMessage id="wallet.statementItem.promotional.user.secondaryDetails.fp.title" />
      ) : (
        <FormattedMessage id="wallet.statementItem.promotional.user.secondaryDetails.rp.title" />
      )
  }

  return (
    <ExpanderItem
      className={className}
      PrimaryElement={() => <PrimaryDetails imgHeightAuto data={primaryDetails} />}
      SecondaryElement={<SecondaryDetails data={secondaryDetails} />}
    />
  )
}

export default injectIntl(withBranding(PromotionalPointsTransfer))
